import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import styles from './supportConnectionDialog.module.scss';

export default memo(function SupportConnectionDialog(props) {
    const [t] = useTranslation(['common', 'auth']);

    useEffect(() => {
        props.getSupportConnectionRequest();
    }, []);

    return (
        <Dialog open={props.open} onClose={props.closeDialog}>
            <DialogTitle>{t('auth:denwa_support_connection')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('auth:denwa_support_connection_detail')}</DialogContentText>
                {
                    props.supportConnection.fetching &&
                    <div className={styles.loaderContainer}>
                        <CircularLoader size={24} />
                    </div>
                }
                {
                    !props.supportConnection.fetching &&
                    props.supportConnection.error &&
                    <div className={styles.cloudError}>
                        <SVG cacheGetRequests className={styles.icon} src="./icons/cloud_error.svg" />
                        <span>{t('common:no_information_available')}</span>
                    </div>
                }
                {
                    !props.supportConnection.fetching &&
                    !props.supportConnection.error &&
                    <>
                        <div className={styles.fieldsContainer}>
                            <TextField
                                disabled
                                type="text"
                                label={t('common:licence_status')}
                                name="licenceStatus"
                                value={
                                    !!props.supportConnection.licenceStatus
                                        ? t('common:active')
                                        : t('common:inactive')
                                }
                                className={styles.field}
                            />
                            <TextField
                                disabled
                                type="text"
                                label={t('common:LICENCE')}
                                name="licence"
                                value={props.supportConnection.licence}
                                className={styles.field}
                            />
                        </div>
                        <div className={styles.fieldsContainer}>
                            <TextField
                                disabled
                                type="text"
                                label={t('common:status')}
                                name="status"
                                value={
                                    props.supportConnection.vpnStatus === 'ok'
                                        ? t('common:connected')
                                        : t('common:unconnected')
                                }
                                className={styles.field}
                            />
                            <TextField
                                disabled
                                type="text"
                                label="IP"
                                name="ip"
                                value={props.supportConnection.ip || ''}
                                className={styles.field}
                            />
                        </div>
                        {
                            props.supportConnection.connectionError &&
                            <div className={styles.connectionError}>
                                <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                                <span>{t('auth:connection_error')}</span>
                            </div>
                        }
                    </>
                }
            </DialogContent>
            <DialogActions>
                <Button autoFocus className={`${styles.actionButton} ${styles.warning}`} onClick={props.closeDialog}>
                    {t('common:cancel')}
                </Button>
                {
                    !props.supportConnection.connecting &&
                    <Button
                        autoFocus
                        disabled={
                            props.supportConnection.vpnStatus === 'ok' ||
                            props.supportConnection.fetching ||
                            !!!props.supportConnection.licenceStatus
                        }
                        className={`${styles.actionButton} ${styles.success}`}
                        onClick={props.connectToSupportVPNRequest}
                    >
                        {t('common:connect')}
                    </Button>
                }
                {
                    props.supportConnection.connecting &&
                    <div className={styles.buttonLoaderContainer}>
                        <CircularLoader size={24} />
                    </div>
                }
            </DialogActions>
        </Dialog>
    );
}, (prevProps, nextProps) =>
        prevProps.open === nextProps.open &&
        prevProps.supportConnection === nextProps.supportConnection
);
